// removed by extract-text-webpack-plugin
module.exports = {"videoList_wrapper":"videosList_videoList_wrapper_z80NQ","videoListItem_wrapper":"videosList_videoListItem_wrapper_1aEgq","left":"videosList_left_1ZAw-","right":"videosList_right_2AKcL","relatedWrapper":"videosList_relatedWrapper_Fj7Dh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/VideosList/videosList.css
// module id = 83
// module chunks = 0